import { Input, Label, Select, Textarea } from "components"
import { Controller, useFormContext } from "react-hook-form"
import { FormWarehouse } from "../types"
import { SelectOptionType } from "types"

type Props = {
  isDisabled?: boolean
  isCodeLoading?: boolean
  locationOptions: SelectOptionType[]
  locationLoading: boolean
}

export function FormSection({ isDisabled, isCodeLoading, locationOptions, locationLoading }: Props) {
  const { control } = useFormContext<FormWarehouse>()

  return (
    <table className="table">
      <tbody>
        <Controller
          control={control}
          name="warehouse_code"
          render={({ field, fieldState }) => (
            <tr>
              <td><Label text="CODE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input {...field} placeholder="Max 3 characters" value={field.value ?? ""} error={fieldState.error?.message} disabled={isDisabled || isCodeLoading} />
              </td>
            </tr>
          )}
        />

        <Controller
          control={control}
          name="location_id"
          render={({ field, fieldState }) => (
            <tr>
              <td><Label text="LOCATION" error={Boolean(fieldState.error)} /></td>
              <td>
                <Select
                  placeholder="Choose location"
                  isDisabled={isDisabled}
                  isLoading={locationLoading}
                  error={fieldState.error?.message}
                  options={locationOptions}
                  value={locationOptions.find(o => o.value?.toString() === field.value?.toString()) ?? null}
                  onChange={e => field.onChange(e?.value ? Number(e.value) : undefined)}
                />
              </td>
            </tr>
          )}
        />

        <Controller
          control={control}
          name="warehouse_name"
          render={({ field, fieldState }) => (
            <tr>
              <td><Label text="WAREHOUSE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Input {...field} placeholder="Warehouse name" value={field.value ?? ""} error={fieldState.error?.message} disabled={isDisabled} />
              </td>
            </tr>
          )}
        />

        <Controller
          control={control}
          name="description"
          render={({ field, fieldState }) => (
            <tr>
              <td><Label text="NOTE" error={Boolean(fieldState.error)} /></td>
              <td>
                <Textarea {...field} value={field.value ?? ""} error={fieldState.error?.message} disabled={isDisabled} />
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  )
}
